function createPane(media) {
  const pane = document.createElement('div');
  pane.className = 'product-image-zoom-pane';
  pane.setAttribute('aria-hidden', 'true');
  media.appendChild(pane);
  return pane;
}

function createLens(media) {
  const lens = document.createElement('div');
  lens.className = 'product-image-zoom-lens';
  lens.setAttribute('aria-hidden', 'true');
  media.appendChild(lens);
  return lens;
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function setupHoverZoom(image, zoomRatio) {
  const media = image.closest('.product__media');
  if (!media || media.dataset.zoomBound === 'true') return;

  media.dataset.zoomBound = 'true';

  let pane = null;
  let lens = null;

  const removeZoom = () => {
    pane?.remove();
    lens?.remove();
    pane = null;
    lens = null;
    media.classList.remove('product__media--zoom-active');
  };

  const updateZoom = (event) => {
    if (!pane || !lens) return;

    const imageRect = image.getBoundingClientRect();
    const paneRect = pane.getBoundingClientRect();

    if (!imageRect.width || !imageRect.height || !paneRect.width || !paneRect.height) return;

    const lensWidth = paneRect.width / zoomRatio;
    const lensHeight = paneRect.height / zoomRatio;

    let x = event.clientX - imageRect.left - lensWidth / 2;
    let y = event.clientY - imageRect.top - lensHeight / 2;

    x = clamp(x, 0, imageRect.width - lensWidth);
    y = clamp(y, 0, imageRect.height - lensHeight);

    lens.style.width = `${lensWidth}px`;
    lens.style.height = `${lensHeight}px`;
    lens.style.left = `${x}px`;
    lens.style.top = `${y}px`;

    pane.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
    pane.style.backgroundSize = `${imageRect.width * zoomRatio}px ${imageRect.height * zoomRatio}px`;
    pane.style.backgroundPosition = `-${x * zoomRatio}px -${y * zoomRatio}px`;
  };

  media.addEventListener('mouseenter', (event) => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(max-width: 749px)').matches) return;
    pane = createPane(media);
    lens = createLens(media);
    media.classList.add('product__media--zoom-active');
    updateZoom(event);
  });

  media.addEventListener('mousemove', updateZoom);
  media.addEventListener('mouseleave', removeZoom);
}

function enableZoomOnHover(zoomRatio) {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    setupHoverZoom(image, zoomRatio);
  });
}

enableZoomOnHover(2);
